import { createSelector } from 'reselect';

const getErrors = state => state.errors;

export default createSelector(
  [getErrors],
  (errors = []) => (
    errors.length > 0
    && errors.some(e => (e === 500 || e.status === 500))
  ),
);
